import { SiderProps, Layout } from "antd";

const { Sider: AntSider } = Layout;

export default function Sider(props: SiderProps) {
  return <AntSider {...props} />;
}
